// Curated Unsplash images for the Calmoras brand — cosmic luxury spiritual wellness
export const images = {
  // Cosmic & celestial
  cosmicNebula:
    'https://images.unsplash.com/photo-1534447677768-be436bb09401?q=80&w=2000&auto=format&fit=crop',
  starfield:
    'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?q=80&w=2000&auto=format&fit=crop',
  galaxy:
    'https://images.unsplash.com/photo-1543722530-d2c3201371e7?q=80&w=2000&auto=format&fit=crop',
  moonNight:
    'https://images.unsplash.com/photo-1532074205216-d0e1f4b87368?q=80&w=2000&auto=format&fit=crop',

  // Meditation & healing
  meditationWoman:
    'https://images.unsplash.com/photo-1545389336-cf090694435e?q=80&w=1200&auto=format&fit=crop',
  yogaPose:
    'https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?q=80&w=1200&auto=format&fit=crop',
  meditationHands:
    'https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=1200&auto=format&fit=crop',

  // Crystals & ritual
  crystals:
    'https://images.unsplash.com/photo-1600618528240-fb9fc964b853?q=80&w=1200&auto=format&fit=crop',
  crystalCluster:
    'https://images.unsplash.com/photo-1518791841217-8f162f1e1131?q=80&w=1200&auto=format&fit=crop',
  candlesRitual:
    'https://images.unsplash.com/photo-1602007900119-bdc6e5b54e6e?q=80&w=1200&auto=format&fit=crop',
  candleFlame:
    'https://images.unsplash.com/photo-1518621736915-f3b1c41bfd00?q=80&w=1200&auto=format&fit=crop',
  incenseSmoke:
    'https://images.unsplash.com/photo-1571689936114-b16146c9570a?q=80&w=1200&auto=format&fit=crop',
  soundBowl:
    'https://images.unsplash.com/photo-1602211844066-d3bb556e983b?q=80&w=1200&auto=format&fit=crop',

  // Energy & healing visuals
  healingHands:
    'https://images.unsplash.com/photo-1518156677180-95a2893f3e9f?q=80&w=1200&auto=format&fit=crop',
  energyLight:
    'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?q=80&w=1200&auto=format&fit=crop',
  auraLight:
    'https://images.unsplash.com/photo-1523287562758-66c7fc58967f?q=80&w=1200&auto=format&fit=crop',

  // Nature & calm
  sunsetMountains:
    'https://images.unsplash.com/photo-1518837695005-2083093ee35b?q=80&w=2000&auto=format&fit=crop',
  forestMist:
    'https://images.unsplash.com/photo-1518495973542-4542c06a5843?q=80&w=1200&auto=format&fit=crop',
  oceanCalm:
    'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=2000&auto=format&fit=crop',

  // Portraits & people
  auroraPortrait:
    'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1000&auto=format&fit=crop',
  womanPeaceful:
    'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=1200&auto=format&fit=crop',
  womanLight:
    'https://images.unsplash.com/photo-1499678329028-101435549a4e?q=80&w=1200&auto=format&fit=crop',

  // Abstract & textures
  goldSmoke:
    'https://images.unsplash.com/photo-1518709268805-4e9042af2176?q=80&w=2000&auto=format&fit=crop',
  purpleAbstract:
    'https://images.unsplash.com/photo-1614851099511-773084f6911d?q=80&w=2000&auto=format&fit=crop',
  cosmicAbstract:
    'https://images.unsplash.com/photo-1462331940025-496dfbfc7564?q=80&w=2000&auto=format&fit=crop',

  // Blog-specific themed
  chakraBlocked:
    'https://images.unsplash.com/photo-1620315808304-66445ccfee0e?q=80&w=1200&auto=format&fit=crop',
  auraCleansing:
    'https://images.unsplash.com/photo-1551845728-6820a30c64e0?q=80&w=1200&auto=format&fit=crop',
  mercuryRetrograde:
    'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?q=80&w=1200&auto=format&fit=crop',
  spiritualBenefits:
    'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?q=80&w=1200&auto=format&fit=crop',
  astrologyDecisions:
    'https://images.unsplash.com/photo-1532968961962-8a0cb3a2d4f5?q=80&w=1200&auto=format&fit=crop',
  energyProtection:
    'https://images.unsplash.com/photo-1518169640858-0a875ed01eea?q=80&w=1200&auto=format&fit=crop',
}

// Map blog post titles to their themed images
export const blogImageMap: Record<string, string> = {
  'Signs Your Chakras Are Blocked': images.chakraBlocked,
  'How Aura Cleansing Works': images.auraCleansing,
  'Understanding Mercury Retrograde': images.mercuryRetrograde,
  'Benefits of Spiritual Healing': images.spiritualBenefits,
  'How Astrology Helps Life Decisions': images.astrologyDecisions,
  'Daily Energy Protection Rituals': images.energyProtection,
}

// Get service hero image based on service slug
export const getServiceImage = (slug: string): string => {
  const map: Record<string, string> = {
    'chakra-balancing': images.crystals,
    'aura-cleansing': images.auraCleansing,
    'astrology-reading': images.cosmicNebula,
    'energy-healing-therapy': images.healingHands,
    'negative-energy-removal': images.candlesRitual,
    'emotional-healing': images.womanPeaceful,
    'stress-relief-sessions': images.oceanCalm,
    'anxiety-relaxation-guidance': images.forestMist,
    'guided-meditation': images.meditationWoman,
    'deep-relaxation-therapy': images.candleFlame,
    'spiritual-energy-balancing': images.energyLight,
    'positive-energy-activation': images.sunsetMountains,
    'mind-calm-sessions': images.meditationHands,
    'sleep-relaxation-healing': images.moonNight,
    'breathwork-healing': images.incenseSmoke,
    'inner-peace-alignment': images.womanLight,
    'personal-energy-reading': images.crystalCluster,
    'meditation-coaching': images.yogaPose,
    'confidence-motivation-healing': images.goldSmoke,
    'emotional-detox-sessions': images.auraLight,
    'spiritual-wellness-guidance': images.soundBowl,
    'focus-clarity-sessions': images.purpleAbstract,
    'premium-healing-programs': images.galaxy,
  }
  return map[slug] || images.cosmicAbstract
}
